import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 170 170" {...props}>
    <g fill="currentColor">
      <path d="M156.018.448H13.983A13.761 13.761 0 00.222 14.208v142.035a13.761 13.761 0 0013.761 13.761h142.035c7.6 0 13.76-6.16 13.76-13.76V14.208c0-7.6-6.16-13.761-13.76-13.761zm3.72 155.795a3.725 3.725 0 01-3.72 3.722H13.983a3.726 3.726 0 01-3.722-3.722V14.21a3.726 3.726 0 013.722-3.722h142.035a3.725 3.725 0 013.72 3.722v142.034z" />
      <path d="M118.047 53.666a6.383 6.383 0 00-8.66-2.468L95.262 59.11a5.019 5.019 0 104.902 8.759l4.743-2.657-15.214 42.299-14.105-20.593a8.382 8.382 0 00-6.725-3.634 8.252 8.252 0 00-6.864 3.337l-16.96 22.55a5.022 5.022 0 108.025 6.04L68.62 94.516l14.7 21.451a8.363 8.363 0 006.902 3.64h.079a8.37 8.37 0 006.922-3.77l17.202-47.46 2.08 3.968a5.018 5.018 0 108.889-4.66l-7.347-14.02z" />
    </g>
  </svg>
);

const IconMatchStatistics = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconMatchStatistics;
